/**
 * - Root routes: standard app shell (bounded viewport + page scroll below `main`).
 * - Nested outlet routes: no shell; height/scroll come from the parent route.
 *
 * Routes that use {@link PageLayout} fill the shell with `flex: 1` and scroll inside their panes.
 */
export type RouteScrollMode = 'document' | 'none';

export function resolveRouteScrollMode(isNestedRoute: boolean): RouteScrollMode {
  return isNestedRoute ? 'none' : 'document';
}
